<template>
  <a :href="url" title="Learn more" :class="badge">
    <figure class="accessory-card-wrapper">
      <img :src="img1x" :srcset="img2x" :alt="alt">
      <p class="p4">{{ product }}</p>
      <figcaption>{{ caption }}
        <span v-if="captionTwo">{{ captionTwo }}</span>
        <span v-if="captionSmall" class="caption-small" v-html="captionSmall" />
      </figcaption>
    </figure>
  </a>
</template>

<script>
  export default {
    name: 'accessorycard',

    props: {
      url: {
        required: true,
        type: String
      },
      product: {
        required: true,
        type: String
      },
      src: {
        required: true,
        type: String
      },
      src2:  {
        required: true,
        type: String
      },
      alt: {
        required: true,
        type: String
      },
      caption: {
        required: true,
        type: String
      },
      captionTwo: {
        required: false,
        type: String
      },
      captionSmall: {
        required: false,
        type: String
      },
      badge: {
        required: false,
        type: String
      }
    },

    computed: {
      img1x() {
        return "https://s3.amazonaws.com/s3.pilates.com/contrology/" + this.src;
      },

      img2x() {
        return "https://s3.amazonaws.com/s3.pilates.com/contrology/" + this.src2 + ' 2x';
      }
    },
  }
</script>

<style lang="scss" scoped>
figure {
  margin: 0;
}

.accessory-card-wrapper {
  width: 100%;
  max-width: 275px;
  background-color: var(--white);
  border-radius: 5px;
  box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.25);
  padding: 8px;
  margin: 12px 0;
}

.VueCarousel .accessory-card-wrapper {
  width: 96%;
  min-height: 195px;
  // max-height: 280px;
}

.VueCarousel figcaption {
  white-space: normal;
  text-align: center;
  height: 60px;
}

.VueCarousel a {
  display: flex;
  justify-content: center;
  height: 100%;
}

img {
  width: 100%;
  display: block;
}

.p4 {
  font-family: var(--roboto);
  font-style: normal;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1;
  text-align: center;
  color: var(--black);
  text-transform: uppercase;
  border-bottom: 0.5px solid var(--black);
  border-top: 0.5px solid var(--black);
  margin: 0;
  padding: 5px;
}

figcaption {
  font-family: var(--roboto);
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.3125;
  color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0 5px;
  white-space: nowrap;
  overflow: hidden;
  flex-direction: column;
}

a {
  text-decoration: none;
  position: relative;
}

.new::after {
  content: "NEW";
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 35px;
  left: 22px;
  width: 58px;
  height: 58px;
  border-radius: 30px;
  border: 2px solid var(--white);
  background-color: var(--black);
  color: var(--white);
}

.caption-small {
  font-size: 0.75rem;
  font-weight: 400;
  text-align: center;
}

@media only screen and (max-width:375px) {
  .VueCarousel figcaption {
    height: auto;
  }
}

@media only screen and (min-width:600px) {
  a {
    margin: 12px;
  }

  .VueCarousel a {
    margin: 0;
  }

  .VueCarousel figcaption {
    height: auto;
  }
}

@media only screen and (min-width:768px) {
  a {
    margin: 0 10px;
  }
}
</style>